import {createBEM} from './bem';
import {isNumber} from './validate';
import {getNamespace} from './namespace';
export function createNamespace(name) {
    name = ''.concat(getNamespace(), '-').concat(name);
    return [createBEM(name)];
}
export function testColor(color) {
    var re1 = /^#([0-9a-f]{6}|[0-9a-f]{3})$/i;
    var re2 = /^[rR][gG][Bb][Aa]?[(]([\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?),){2}[\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?),?[\s]*(0\.\d{1,2}|1|0)?[)]{1}$/g;
    var re3 = /linear-gradient/g;
    return re2.test(color) || re1.test(color) || re3.test(color);
}
export function oneOf(value, validList) {
    for (var i = 0; i < validList.length; i++) {
        if (value === validList[i]) {
            return true;
        }
    }

    return false;
}
export function noop() {}
export function throttle(fn, delay, immediate, debounce) {
    var curr = +new Date();
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var context;
    var args;

    var exec = function exec() {
        lastExec = curr;
        fn.apply(context, args);
    };

    return function() {
        curr = +new Date();
        context = this;

        for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
            rest[_key] = arguments[_key];
        }

        args = rest;
        diff = curr - (debounce ? lastCall : lastExec) - delay;
        clearTimeout(timer);

        if (debounce) {
            if (immediate) {
                timer = setTimeout(exec, delay);
            } else if (diff >= 0) {
                exec();
            }
        } else {
            if (diff >= 0) {
                exec();
            } else if (immediate) {
                timer = setTimeout(exec, -diff);
            }
        }

        lastCall = curr;
    };
}
export function debounce(fn, delay, immediate) {
    return throttle(fn, delay, immediate, true);
}
export function isDef(val) {
    return val !== undefined && val !== null;
}
export function acceptCssUnit(value) {
    var defaultUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';

    if (typeof value === 'string') {
        var matched = value.match(/^\d+([a-zA-z%]+)$/);

        if (matched && matched[1]) {
            return ''.concat(parseInt(value)).concat(matched[1]);
        }
    }

    return ''.concat(value).concat(defaultUnit);
}
export function addUnit(value) {
    if (!isDef(value)) {
        return undefined;
    }

    value = String(value);
    return isNumber(value) ? ''.concat(value, 'px') : value;
}
var zIndex = 9095;
export function getZIndex() {
    zIndex += 1;
    return zIndex;
}
